module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"about":"About {0}"}}')
  delete Component.options._Ctor
}
